export const valuationChangeRequiresVerification = (
  current: number,
  previous: number
) => {
  return current >= 2 * previous || current <= 0.5 * previous;
};

export default valuationChangeRequiresVerification;
